import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProyectosService } from '../../../services/proyectos.service';

@Component({
  selector: 'app-metro-lima',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './metro-lima.html',
  styleUrl: './metro-lima.css'
})
export class MetroLimaComponent implements OnInit {
  proyectosRecomendados: any[] = [];

  constructor(private proyectosService: ProyectosService) {}

  ngOnInit() {
    this.proyectosRecomendados = this.proyectosService.getProyectosAleatorios('/proyectos/metro-lima');
  }
}
